module.exports = __webpack_public_path__ + "media/images/flags/SC-e09f1cedc3c9dbc368ddb840ff22509b.svg";